module.exports = {
  title: 'SID Technology'
}



// WEBPACK FOOTER //
// ./src/settings.js